<template>
    <div>
        <h1 class="mb-4">Servicios</h1>
        <hr>
        <CardService 
            title="Desarrollo Web" 
            description="Estas en busca de una solucion web, necesitas llevar un control de informacion, generar informes, diferentes modulos, estadisticas, impresion, roles, te puede ayudo a desarrollarlos"
        />
        <CardService 
            title="App moviles" 
            description="Con una app, puedes prestar uno varios servicios, ofrecer informacion mas detallada sobre tu negocio, eventos, noticias. app local, guardar y consultar dicha informacion, app remota disponibilidad en cualquier lugar"
        />
        <CardService 
            title="Programas de escritorio" 
            description="Requieres tener un control del servicio que ofreces a travez de un programa de escritorio, generar reportes, diferentes funcionalidades, impresion. (desarrollo a travez de java)"
        />
        <CardService 
            title="Acesorias" 
            description="Necesitas ayuda, acompañamiento, desarrollar tu proyecto web - movil, soluciones de errores o desarrollo de alguno de los proyectos"
        />
    </div>
</template>

<script>
    import CardService from './CardService.vue'
    export default {
        components:{
            CardService
        }
    }
</script>